import axios from 'axios';
import {getCookie, getLoginUrl, getRefreshTokenUrl, getTargetUrl, isOKta, logout} from '../utils/Utils'
import {isValidImpersonation} from "../components/util/helper";

const jwt = require('jsonwebtoken');
const authAxios = axios.create();

authAxios.interceptors.request.use((config) => {
    return config;
}, function (error) {
    if (error && error.response && error.response.status === 401) {
        logout(window.location)
    } else {
        throw error
    }
});

const tokenKey = `QID-${process.env.REACT_APP_ENV_SN}-JWT-TOKEN`;
const LOCAL_TOKEN_KEY = 'QID-DEV-JWT-TOKEN';

export const setSession = (value) => {
    localStorage.setItem(tokenKey, value);
};

export const getSessionToken = () => {
    if (isLocalhost()) {
        const localToken = localStorage.getItem(LOCAL_TOKEN_KEY);
        if(localToken) {
            return localToken;
        }
    }
    return localStorage.getItem(tokenKey);
};

export const setLocalToken = (token) => {
    if (token) {
        localStorage.setItem(LOCAL_TOKEN_KEY, token);
    } else {
        localStorage.removeItem(LOCAL_TOKEN_KEY);
    }
};

export const getLocalToken = () => {
    return localStorage.getItem(LOCAL_TOKEN_KEY);
};

export const hasLocalToken = () => {
    return !!localStorage.getItem(LOCAL_TOKEN_KEY);
};

export const isLocalhost = () => {
    return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
};

export function removeSessionToken() {
    localStorage.removeItem(tokenKey);
}

export const readTokenFromParams = (props) => {
    const search = props.location.search || null;
    let token;
    if (search) {
        const params = new URLSearchParams(search);
        token = params.get('token');
    }
    return token;
};

export const isTokenExpired = (jwtToken) => {
    const token = jwtToken || getSessionToken();
    const user = token && jwt.decode(token);
    let softexp = user && user.exp - 300;
    if (Math.floor(Date.now() / 1000) > softexp) {
        return true
    }
    if (user.impersonationStatus) {
        if (!isValidImpersonation(user.impersonationStatus)) {
            return true
        }
    }
    return false
};

let refreshPromise = null;

export const refreshTokenWithSessionId = async (sessionId) => {
    const isOktaEnabled = isOKta()

    if (!refreshPromise) {
        refreshPromise = authAxios.post(getRefreshTokenUrl(), {
            sessionId: sessionId,
            isOkta: isOktaEnabled
        });

        refreshPromise.then((response) => {
            const token = response.data && response.data.jwtToken ? response.data.jwtToken : null;
            if (token) {
                setSession(token);
                return token;
            } else {
                logout(window.location)
            }
        }).catch((error) => {
            throw error
        }).finally(function () {
            refreshPromise = null;
        });
    }

    return refreshPromise;
};

export const refreshToken = async (expiredToken) => {
    const decodedToken = jwt.decode(expiredToken);
    if (!decodedToken || !decodedToken.sessionId) {
        throw new Error('Invalid token: sessionId not found');
    }
    return refreshTokenWithSessionId(decodedToken.sessionId);
};

export const getSessionIdFromCookie = () => {
    console.log('Looking for cookie with name:', tokenKey);
    let sessionId = getCookie(tokenKey);
    console.log('Cookie value:', sessionId);

    if (!sessionId) {
        const qidSessionCookieName = ('prd' === process.env.REACT_APP_ENV_SN) ? 'QID_SESSION' : `QID_${process.env.REACT_APP_ENV_SN.toUpperCase()}_SESSION`;
        sessionId = getCookie(qidSessionCookieName);
        console.log('Cookie value from QID_SESSION', sessionId);
    }
    console.log("sessionId::" + sessionId);
    return sessionId;
};

export const getTokenFromSessionCookie = async () => {
    const sessionId = getSessionIdFromCookie();
    if (!sessionId) {
        console.warn('Session ID not found in cookie');
        return Promise.reject(new Error('Session ID not found in cookie'));
    }

    console.log('Refreshing token with sessionId:', sessionId);
    return refreshTokenWithSessionId(sessionId);
};


export const isValidSession = (token) => {
    console.log("isValidSession called")
    
    if (isLocalhost() && hasLocalToken()) {
        return true;
    }
    
    const user = token && jwt.decode(token);
    const sessionId = getSessionIdFromCookie();
    const localStorageToken = user && user.sessionId;
    return !!sessionId && (localStorageToken === sessionId)
};

export function getCurrentUser() {
    try {
        const token = getSessionToken();
        if (token) {
            if (!isValidSession(token)) {
                localStorage.removeItem(`QID-${process.env.REACT_APP_ENV_SN}-JWT-TOKEN`);
                return null
            } else {
                const user = jwt.decode(token);
                return user;
            }
        } else {
            return null
        }
    } catch (ex) {
        return null
    }
}


export const isJwtExpired = (jwtToken) => {
    const token = jwtToken || getSessionToken();
    const user = token && jwt.decode(token);
    return !user
}

export const checkAcrValues = () => {
    const token = getSessionToken();
    const user = token && jwt.decode(token);
    if(!(user.idToken && jwt.decode(user.idToken).acr) && isOKta()){
        console.log("No ACR Value")
        const url = `${getLoginUrl()}?state=${getTargetUrl()}`;
        window.location = url
    }
}


const isExternalUser = (username) => {
    const sessionUser = getCurrentUser();
    const loggedInUserName = username || (sessionUser && sessionUser.username)
    return (loggedInUserName && loggedInUserName.indexOf("@") > -1);

}
const getImpersonationStatus = () => {
    const token = getSessionToken();
    const user = token && jwt.decode(token);
    return (user && user.impersonationStatus)
}
/*const readOktaJwt = () => {
    const token = getSessionToken();
    const jwtClaims = token && jwt.decode(token);
    const {idToken: oktaIdToken} = jwtClaims

    if (oktaIdToken) {
        return jwt.decode(oktaIdToken)
    }
    return {}


}*/

export const checkTokenValidity = (token) => {
    const userToken = token || getSessionToken();
    if (!userToken) {
        window.location.reload()
    } else if (isJwtExpired(userToken)) {
        logout(window.location);
    }
}


export default {
    loginWithToken: setSession,
    logout,
    getCurrentUser,
    readTokenFromParams,
    isExternalUser,
    getImpersonationStatus,
    refreshTokenWithSessionId,
    getSessionIdFromCookie,
    getTokenFromSessionCookie,
    getSessionToken,
    setLocalToken: setLocalToken,
    getLocalToken: getLocalToken,
    hasLocalToken: hasLocalToken,
    isLocalhost
};

